import { createSlice } from '@reduxjs/toolkit';

import { SupplierSyncEvent, SupplierSyncEventStatus } from '@dill/dill-shared';
import { getSupplierSyncHistoryExtraReducer } from '../reducers/syncHistoryReducers';

export interface SyncHistoryInitialState {
  loadingList: string[];
  syncEvents: SupplierSyncEvent[];
  /** Status of the newest finished sync; only taken from ranges that reach the present. */
  latestSyncStatus: SupplierSyncEventStatus | null;
}

const initialState: SyncHistoryInitialState = {
  loadingList: [],
  syncEvents: [],
  latestSyncStatus: null,
};

export const syncHistorySlice = createSlice({
  name: 'syncHistory',
  initialState,
  reducers: {
    resetSyncHistoryRootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierSyncHistoryExtraReducer(builder);
  },
});

export const { resetSyncHistoryRootState } = syncHistorySlice.actions;
